<template>
	<div id="appbox">
		<div class="top_heard">
			<div class="top_box">
				<div class="logo_box"  @click="gohome()">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
				<div class="top_gatebox">
					<div class="manage_switch" v-if="screenWidth>785">
						<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
						  <el-option
						    v-for="item in manageoptions"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							>
						  </el-option>
						</el-select>
					</div>
					
				</div>
				<div class="top_search_box">
			<!-- 		<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
						    v-for="item in options"
						    :key="item.value"
						    :label="item.label" 
						    :value="item.value">
						  </el-option>
						</el-select>
						<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="getlist()" alt="" srcset="">
					</div> -->
					  
					  
				</div>
				<div class="top_right">
					<div class="top_Mobiletype" @click="goregister()">
						账号注册/绑定
					</div>
					<div class=""  v-if="token" >
						欢迎访问!
					</div>
					<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
						登出
					</div>
				</div>
			</div>
			<div class="top_tab_box">
				<div class="toptabnav">
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  mode="horizontal"
						 
						  router
						  background-color="#1b9d57"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
							<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
				
			</div>
		</div>
		<div class="Home_column2">
		
			<div class="weus_main">
				<div class="weus_topimg">
					<img src="../../../static/img/weus1.jpg" alt="" srcset="">
				</div>
				<div class="weus_titles">
					<div class="weus_title">
						河南省研学旅行教育精品课程认证说明
					</div>
					
				</div>
				
				<div  >
						<div class="intro_msg">
						<div class="intro_title"></div>
						<div class="intro_content">为深入贯彻河南省教育厅等10部门《关于推进中小学生研学旅行的实施方案》等文件精神，充分挖掘河南研学资源优势，研发具有河南特色的研学课程体系，扎实推进中小学研学实践教育“五个一”精品工程,河南省研学旅行教育协会（以下简称“协会”）决定启动“河南省研学旅行精品课程”认证工作，就有关事项说明如下：</div>
						<div>
							<div class="intro_subtitle">一、组织机构</div>
							<div class="intro_content">主办单位：河南省研学旅行教育协会。</div>
						</div>
                        <div>
							<div class="intro_subtitle">二、认证对象</div>
							<div class="intro_content">河南省研学旅行教育从业单位。</div>
						</div>
						<div>
							<div class="intro_subtitle">三、内容要求</div>
							<div class="intro_paragraph">（一）课程主题</div>
                            
							<div class="intro_paragraph intro_paragraph2">聚焦教育改革和研学创新，关注研学旅行的多元形式与特色资源的活化利用，研学课程应做到挖掘深、定位准、特色明。申报课程可围绕以下六大板块开展：</div>
							<div class="intro_paragraph intro_paragraph2">1.优秀传统文化：利用博物馆、非遗场所、优秀传统文化精品课程等资源设计的，旨在引导学生传承中华优秀传统文化理念、人文精神和文化自信的“文化之旅”课程；</div>
							<div class="intro_paragraph intro_paragraph2">2.革命传统教育：利用革命历史遗址、爱国主义精品课程等设计的，旨在引导学生了解革命历史，培养爱国主义情怀的“红色之旅”课程；</div>
							<div class="intro_paragraph intro_paragraph2">3.国防科工：利用国家安全精品课程、国防精品课程、科技馆、科普精品课程、高校、科研院所等设计的，旨在培养学生学习科学知识、科学兴趣和研究创新意识的“科研之旅”课程；</div>
							<div class="intro_paragraph intro_paragraph2">4.自然生态：利用自然景区、城镇公园、植物园、动物园、生态保护区、野生动物保护基地、示范性农业基地等资源设计的，旨在培养学生生态文明意识的“生态之旅”课程；</div>
							<div class="intro_paragraph intro_paragraph2">5.国情教育：利用美丽乡村、传统村落、特色小镇、大型知名企业、历史文化名城等资源设计的，旨在引导学生全面了解国家的历史、文化、社会、经济和自然环境，激发学生爱党爱国情感和国家自豪感的“国情探索之旅”课程。</div>
							<div class="intro_paragraph">（二）课程要求</div>
							<div class="intro_paragraph intro_paragraph2">立足河南省特色，课程设计应充分挖掘、研究、整合省内优质传统文化教育资源、革命传统教育资源、博物馆资源、科技场馆资源、美丽乡村、工业产业等丰富多样的研学资源。研学课程还应符合：</div>
							<div class="intro_paragraph intro_paragraph2">1.原创性。课程须由申报单位/团队/个人自主开发。符合研学旅行的宗旨和要求，能满足学生研学实际需要；</div>
							<div class="intro_paragraph intro_paragraph2">2.科学性。课程结构完整，一般包含课程名称、课程资源、课程目标、课程实施、课程评价、研学手册、安全保障等，课程设计科学，内容编排合理，实施规范，管理到位；</div>
							<div class="intro_paragraph intro_paragraph2">3.安全性。课程设计与实施应遵循安全第一、生命至上的原则，全面考虑，确保广大师生安全；</div>
							<div class="intro_paragraph intro_paragraph2">4.教育性。课程内容需体现和贯彻“立德树人”“实践育人”的教育思想，聚焦中小学生发展核心素养，突出德育实效，注重体育健康和劳动教育，将社会主义核心价值观融入研学旅行教育活动全过程，面向学生的个体生活和社会生活，突出学生的能力培养，彰显研学旅行课程特色；结合学生身心特点、接受能力和实际需要，注重系统性和知识性、科学性和趣味性；</div>
							<div class="intro_paragraph intro_paragraph2">5.实践性。课程应呈现地域特色，让学生在实践、实验、探究、设计、创作等过程中体验和感受生活，能拓展视野、丰富知识、发展实践创新能力。</div>
						</div>
						<div>
							<div class="intro_subtitle">四、认证程序</div>
							<div class="intro_paragraph">（一）单位申报</div>
							<div class="intro_paragraph intro_paragraph2">申报单位根据遴选通知向协会递交申报材料。</div>
                            <div class="intro_paragraph">（二）初步审核</div>
							<div class="intro_paragraph intro_paragraph2">协会组织专家对各单位申报材料进行初步审核，确认初审通过名单，由协会通知通过初审单位提交复审材料。</div>
                            <div class="intro_paragraph">（三）复审</div>
							<div class="intro_paragraph intro_paragraph2">协会组织专家对初审通过单位进行材料复审，确认复审通过名单，由协会通知通过复审单位提交线上宣传材料。</div>
                            <div class="intro_paragraph">（四）公示及公布</div>
							<div class="intro_paragraph intro_paragraph2">协会对最终结果进行网络及现场公示、公布。</div>
                            <div class="intro_paragraph">（五）课程展示</div>
							<div class="intro_paragraph intro_paragraph2">以河南省中小学生研学旅行服务平台为载体，对通过复审的课程在平台上进行展示推广。</div>
                            <div class="intro_paragraph">（六）授牌及证书</div>
							<div class="intro_paragraph intro_paragraph2">协会对入选单位授予“河南省研学旅行精品课程”证书。</div>
							<img src="../../../static/img/zhengshu.jpg" alt="" style="width: 800px;height: auto;">

							
						</div>
						<div>
							<div class="intro_subtitle">五、申报材料</div>
							<div class="intro_paragraph">1.填写申报书（附件1），并提供电子版（Word文档和PDF）和签字盖章纸质版各1份。</div>
							<div class="intro_paragraph">2.“河南省研学旅行精品课程”申报书电子版按要求发送至指定邮箱；纸质版彩色双面打印各一份，分开装订成册并加盖公章快递至指定地点。</div>
							<div class="intro_paragraph">3.申报单位认为需要提交的其他补充材料。</div>
							<div class="intro_paragraph">4.务必确保申报材料整体版面工整，内容完整，字迹清晰，图片清晰可辨。</div>
						</div>
						<div>
							<div class="intro_subtitle">六、申报要求</div>
							<div class="intro_paragraph intro_paragraph2">请相关单位将“河南省研学旅行精品课程”申报书的电子版和纸质版材料报送至河南省研学旅行教育协会：</div>
                            <div class="intro_paragraph">（一）电子版材料</div>
							<div class="intro_paragraph intro_paragraph2">电子版以压缩文件包的形式发送hnsyxlxjyxh@126.com，邮件主题及电子材料命名为：单位名称—“河南省研学旅行精品课程”申报材料。</div>
                            <div class="intro_paragraph">（二）纸质版材料</div>
							<div class="intro_paragraph intro_paragraph2">纸质版材料一式一份，邮寄地址：郑州市金水东路与民生路交叉口永和国际广场B区712室。</div>
							
                            
							
						</div>
						
						<div class="intro_subtitle">七、联系方式</div>
						<div style="padding-left: 35px;">
							<div class="intro_phone">联系人：王 佳</div>
						<div class="intro_phone">联系电话：18336055555</div>
						
				
						
						</div>
                        <div>
							<div class="intro_subtitle">八、声明</div>
							<div class="intro_paragraph">1.2025年“河南省研学旅行精品课程”认证工作由河南省研学旅行教育协会主办；</div>
							<div class="intro_paragraph">2.入选单位需承担198元/单位的认证费，由协会工作人员负责通知上缴；</div>
							<div class="intro_paragraph">3.申报单位视为认同本声明内容；</div>
							<div class="intro_paragraph">4.活动最终解释权归主办方。</div>
							
						</div>
						<div class="intro_phone" style="text-decoration: underline;color: blue;margin-top: 20px;width: 1200px;" @click="downfile('https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/henan/%E9%99%84%E4%BB%B61%EF%BC%9A%E6%B2%B3%E5%8D%97%E7%9C%81%E7%A0%94%E5%AD%A6%E6%97%85%E8%A1%8C%E7%B2%BE%E5%93%81%E8%AF%BE%E7%A8%8B%E8%AE%A4%E8%AF%81%E7%94%B3%E6%8A%A5%E8%A1%A8.docx')">
							附件：1.河南省研学旅行精品课程认证申报表.docx
						</div>
						<div class="intro_phone" style="text-decoration: underline;color: blue;width: 1200px;"  @click="downfile('https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/henan/%E9%99%84%E4%BB%B62%EF%BC%9A%E6%B2%B3%E5%8D%97%E7%9C%81%E7%A0%94%E5%AD%A6%E6%97%85%E8%A1%8C%E7%B2%BE%E5%93%81%E8%AF%BE%E7%A8%8B%E8%AF%84%E5%AE%9A%E6%A0%87%E5%87%86.docx')">附件：2.河南省研学旅行精品课程评定标准.docx</div>
                        <div class="intro_phone" style="text-decoration: underline;color: blue;width: 1200px;"  @click="downfile('https://yxwy-1254115215.cos.ap-beijing.myqcloud.com/henan/%E9%99%84%E4%BB%B63%EF%BC%9A%E6%B2%B3%E5%8D%97%E7%9C%81%E7%A0%94%E5%AD%A6%E6%97%85%E8%A1%8C%E7%B2%BE%E5%93%81%E8%AF%BE%E7%A8%8B%E7%AE%A1%E7%90%86%E5%8A%9E%E6%B3%95.docx')">附件：3.河南省研学旅行精品课程管理办法.docx</div>
						<!-- <div style="text-align: end;margin-top: 30px;">河南省研学旅行教育协会</div>
						<div style="text-align: end;margin-top: 10px;">2023年8月8日</div>
						<div class="intro_phone" style="display: flex;width: 1200px;">
							原文链接：
							<a  href="https://mp.weixin.qq.com/s/9YWUxnXQh2vGo-E3DKNvZA" style="text-decoration: underline;color: blue;" target="_blank" rel="noopener noreferrer">https://mp.weixin.qq.com/s/9YWUxnXQh2vGo-E3DKNvZA</a>
						</div>
						<div style="text-align: start;margin-bottom: 10px;margin-top: 10px;font-size: 18px;letter-spacing: 1px;">入会报名:</div>
						<img src="../../../static/img/baoming.png" alt=""> -->
					</div>
				</div>
			</div>
		</div>
		<div :class="tops?'navbar':'navbar-top'">
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		 <el-dialog
		   title="您还未登录,请登录后再操作"
		   :visible.sync="loginshow"
		    :before-close="onAgain"
		   width="30%"
		   center>
		   <el-form ref="form" :model="form" :rules="rules"  label-width="100px">
		 	  <el-form-item label="手机端账号" prop="mobile">
		 	      <el-input v-model="form.mobile"></el-input>
		 	    </el-form-item>
		 		 <el-form-item label="密码" prop="password">
		 		    <el-input type="password" v-model="form.password" ></el-input>
		 		  </el-form-item>
		 	  <div class=""  @click="goregister()" style="color: #409EFF;width: 100%;text-align: right;">
		 	  	注册账号
		 	  </div>
		 	  
		   </el-form>
		   <span slot="footer" class="dialog-footer">
		    <el-button @click="loginshow = false" style="margin-right: 15px;">取 消</el-button>
		    <el-popover
		      placement="top"
		    	v-model="showvisible"
		       trigger="manual">
		      <div class="verify-box">
		      	<slide-verify
		      	  ref="slideRef"
		      	  :l="42"
		      	  :r="10"
		      	  :w="280"
		      	  :h="280"
		      	  :imgs="images"
		      	  slider-text="向右滑动"
		      	  @success="onSuccess"
		      	  @fail="onFail"
		      	  @refresh="onRefresh"
		      	  @fulfilled="onRefreshComplete"
		      	  @again="onAgain"
		      	>
		      	</slide-verify>
		      </div>
		      <el-button type="primary" slot="reference" @click="showvisible = true">登 录</el-button>
			</el-popover>
		   </span>
		 </el-dialog>
		<!-- footer -->
		<div class="pagesbottom_box">
			<div class="subtexts">
				<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				<!-- 				<div>商务合作</div>
								<div>招商合作</div>
								<div>广告服务</div>
								<div>线下体验店</div>
								<div>客服中心</div>
								<div>在线留言</div>
								<div>合作伙伴</div>
								<div>联系我们</div>
								<div>人员招聘</div>
								<div>网站地图</div>
								<div>热点关注</div>
								<div>网盟合作</div>
								<div>音乐</div> -->
			</div>
			<div class="row">
				<!-- <div class="copy-left">
					<p><i class="el-icon-phone-outline"></i>{{pcsetdata.phone}}</p>
					<p><i class="el-icon-message"></i>{{pcsetdata.email}}</p>
					<p style="font-size: 13px;">地址信息：{{pcsetdata.address}}</p>
				</div> -->
				
				<div class="copy-left">
					<div class="bottom_logo">
						<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div>
					<!-- <div class="bottom_logo">
						<img src="../../../static/img/logo2.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
					</div> -->
					<!-- <div class="copy-right">
						<img src="../../../static/img/gzhsuncode.jpg" />
					</div>
					<div class="copy-right">
						<img src="../../../static/img/suncode.jpg" />
					</div> -->
				</div>
				<div class="bottom_right">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {  checktoken, regettoken, getCamplist, getPc, getRegion ,getTraveler, getPlate,phonelogin,getexpert,getsys,upadvocate,getbottomnav} from '@/request/api'
	
	export default {
	  name: "Camplist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  top_search_url:'/weus',
			  manage_url:'',
			  manageoptions:[
			  	{
			  	  value: 'http://qianjin.wanjiaxiao.cn/',
			  	  label: '研学报备'
			  	}, {
			  	  value: 'https://admin.henanyanxue.com/',
			  	  label: '管理入口'
			  	},
			  
			  ],
			  stitle:'',
			  title:'关于我们',
			  options: [{
			  		  value: '/weus',
			  		  label: '专家搜索'
			  		},],
				platelist:[],
				activeIndex2: '/weus',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				expertdata:{},
				banner:[
				],
				ruleForm: {
				  title: '',
				  contact: '',
				  content: '',
				  type:1,
				},
				rules: {
					contact: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' },
					],
					title: [
						{ required: true, message: '请填写主题', trigger: 'blur' },
					],
					content: [
						{ required: true, message: '请填写留言内容', trigger: 'blur' },
					],
				},
				camptypes:[
					{ text: '全部', value: 0 },
					{ text: '基地', value: 2 },
					{ text: '营地', value: 1 },
				],
				camptype:1,
				camplist:[],
				quicklist:[],
				maplist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				openmap:{},
				show: false,
				showinfowindow:false,
				regionlist:[],
				region_type:'',
				modules:'',
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:0,
				richbox:'',
				//强制登录
				loginshow:false,
				replytext:'',
				form: {
					mobile: '',
					password: '',
					openid:'',
					unionid:'',
					is_pc:1,
				},
				//滑块验证码
				images: [
					require('../../../static/img/滑块1.jpg'),
					require('../../../static/img/滑块2.jpg'),
					require('../../../static/img/滑块3.jpg')
				],
				tipsMsg:'',
				isSuccess: true,
				showvisible:false,
				//反馈滑块
				showreplyvisible:false,
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		  this.getpcset()  
		//    this.gotop()
		    document.documentElement.scrollTop=0
	  },
	  mounted() {
		 const { title } = this.$route.query;
		 this.title=title
		 var token = localStorage.getItem('token')||''
		 this.token=token
		  this.getbottomnav()
		//   this.gotop()
		 // this.getsys()
		 console.log("滚轮位置",this.scrolltop)
		window.addEventListener('scroll', this.scrollToTop)
		
		
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  methods: {
		downfile(url){
				  this.$message({
          message: '已下载',
          type: 'success'
        });
			  window.open(url);
		},	
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		//this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  onreplySuccess(){
		  						  // this.isSuccess = true;
		  						  this.showreplyvisible=false
		  						  this.upadvocate()
		  						  this.$refs.replyRef.reset();
		  },
		  onreplyFail(){
		  						  
		  },
		  onreplyRefresh(){
		  			  
		  },
		  onreplyAgain(){
		  			   this.$refs.replyRef.reset();
		  			   this.showreplyvisible=false
		  			  // this.loginshow=false
		  },
		  // 成功回调
		  			  onSuccess(){
		  				  this.tipsMsg = '恭喜您，验证成功啦！';
		  				  this.isSuccess = true;
		  						  this.showvisible=false
		  						  this.phonelogin()
		  						  this.$refs.slideRef.reset();
		  			  },
		  			  // 失败回调
		  			  onFail(){
		  				  this.tipsMsg = '验证失败，请重试哦！';
		  				  this.isSuccess = false;
		  			  },
		  			  // 点击刷新回调
		  			  onRefresh(){
		  				  this.tipsMsg = ''
		  			  },
		  			  // 刷新成功后回调
		  			  onRefreshComplete(){
		  						  this.tipsMsg = ''
		  						  this.isSuccess = true;
		  			  },
		  			  // 检测到非人为操作
		  			  onAgain() {
		  						  
		  						this.$refs.slideRef.reset();
		  						 this.showvisible=false
		  						this.loginshow=false
		  			  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  typetab(title){
			  
			  this.title=title;
			  if(title=='关于我们'){
				  console.log(title,title=='关于我们')
				this.richbox=this.pcsetdata.aboutus
			  }
			  if(title=='在线留言'){
			  	this.richbox=''
				this.ruleForm={
				  title: '',
				  contact: '',
				  content: '',
				  type:1,
				}
			  }
			  if(title=='建议反馈'){
			  	this.richbox=''
			  	this.ruleForm={
				  title: '',
				  contact: '',
				  content: '',
				  type:2,
				}
			  }
			  if(title=='隐私权保护'){
				this.richbox=this.pcsetdata.privacy	  
			  }
			  if(title=='注册协议'){
				this.richbox=this.pcsetdata.registration_agreement
			  }
		  },
		  gologin(){
		  			  this.$router.push({
		  			    path: "/Login",
		  			    name: "/Login",
		  				  query: {
		  				  }
		  			  });
		  },
		  upadvocate(){
			  var token = localStorage.getItem('token')||''
			  if(!token){
				   this.gologin()
			    // this.loginshow = true
			    return
			  }
			  var data={
			    
			  }
			  checktoken(data).then(res=>{
			    if(res.data.code==201){
			  	  console.log(res)
			  	  regettoken(data).then(res=>{
			  		  localStorage.setItem('token', res.data.data.token)
			  		  localStorage.setItem('refreshToken', res.data.data.refreshToken)
			  	  })
			    }
			    // if(res)
			  })
			data=this.ruleForm
			  if(!this.ruleForm.contact){
			    this.$alert('联系方式未填写', '联系方式未填写', {
			  	confirmButtonText: '确认',
			  	callback: action => {
			  		
			  	}
			    });
			    return
			  }
			if(!this.ruleForm.title){
			  this.$alert('主题未填写', '主题未填写', {
				confirmButtonText: '确认',
				callback: action => {
					
				}
			  });
			  return
			}
			if(!this.ruleForm.content){
			  this.$alert('内容未填写', '内容未填写', {
				confirmButtonText: '确认',
				callback: action => {
					
				}
			  });
			  return
			}
			upadvocate(data).then(res=>{
				if(res.data.code==200){
					this.$alert('留言成功', '留言成功', {
						confirmButtonText: '确认',
						callback: action => {
							this.richbox=''
							this.ruleForm={
							  title: '',
							  contact: '',
							  content: '',
							  type:this.ruleForm.type,
							}
						}
					});
									 
				}
			})  
		  },
		  phonelogin(){
		  			  var data=this.form
		  			  var that=this
		  			  if(this.form.mobile==''){
		  						this.$alert('请输入登录手机号', '请输入登录手机号', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								
		  							}
		  						});
		  				return;
		  			  }
		  			  if(this.form.mobile.length!=11){
		  						this.$alert('手机号长度位数错误', '手机号长度错误', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								
		  							}
		  						});
		  				return;
		  			  }
		  			  if( this.form.password==''){
		  						this.$alert('请填写密码', '存在未填项', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								
		  							}
		  						});
		  				return;
		  			  }
		  			  phonelogin(data).then(res=>{
		  				  if(res.data.data.flag==0){
		  				  					  this.$alert(res.data.data.msg, '账号不存在', {
		  				  					  	confirmButtonText: '确认',
		  				  					  	callback: action => {
		  				  					  		that.goregister()
		  				  					  	}
		  				  					  });
		  				  					  return
		  				  }
		  				  if(res.data.data.flag==2){
		  				  						  this.$alert(res.data.data.msg, '没有设置密码', {
		  				  							confirmButtonText: '确认',
		  				  							callback: action => {
		  				  								that.goreset()
		  				  							}
		  				  						  });
		  				  						  return
		  				  }
		  				  localStorage.setItem('token', res.data.data.token)
		  				  localStorage.setItem('refreshToken', res.data.data.refreshToken)
		  				  this.$router.go(0)
		  				  // this.$localStorage.set('token',res.data.data.token)
		  				  // this.$localStorage.set('refreshToken',res.data.data.refreshToken)
		  			  })
		  },
		  getsys(){
			getsys().then(res=>{
				this.richbox=res.data.registration_agreement
			})  
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showstep(ind) {
		       this.$refs.carousel.setActiveItem(ind)
		     },
		  goplate(id){
			  this.modules=id
			  this.page_index=1
			  this.getlist()
		  },
		  getexpert(){
			  var data={
			  	uuid:this.uuid
			  }  
			  getexpert(data).then(res=>{
					console.log(res.data)
					this.expertdata=res.data.data
					const loading = this.$loading({
			  			           lock: true,
			  			           text: 'Loading',
			  			           spinner: 'el-icon-loading',
			  			           background: 'rgba(0, 0, 0, 0.7)'
			  			         });
					loading.close();
			  			  // this.quicklist=res.data.data.list
			    }).catch(error => {
			  	  console.error(error);
			  });
		  },
		  getPlate(){
		  		var data={
		  			
		  		}  
		  		getPlate(data).then(res=>{
		  			this.platelist=res.data.data
		  		})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
		  getRegion(){
			var data={}
			getRegion(data).then(res=>{
				this.regionlist=res.data.data
			})
		  },
			getMapcamp(){
				var data={
					type:this.camptype,
				}
				getMapcamp(data).then(res=>{
					console.log(res)
					
					this.maplist=res.data.data
					this.openmap=res.data.data[0]
					const loading = this.$loading({
							 lock: true,
							text: '页面载入……',
							// spinner: 'el-icon-loading',
							background: '#ffffff'
						   });
					loading.close();
				})
			},
			infoWindowClose (index) {
		        this.showinfowindow = false
			},
			infoWindowOpen (index) {
				this.openmap=this.maplist[index]
				this.showinfowindow = true
				console.log(this.maplist[index])
			},
			
			getpcset(){
				getPc().then(res=>{
					this.pcsetdata=res.data.data
					const loading = this.$loading({
							 lock: true,
							 text: 'Loading',
							 spinner: 'el-icon-loading',
							 background: 'rgba(0, 0, 0, 0.7)'
						   });
					loading.close();
					this.typetab(this.title)
				})  
			},
		  camptypetab(val){
			  this.region_type=val
			  this.page_index=1
			  this.getlist()
		  },
		  pagechange(val){
		  			  this.page_index=val
		  			   this.getlist()
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		  /*
		   * 查看详情
		   * */
		  detail(e) {
		    this.$router.push({
		      path: "/travelerdetails",
		      name: "travelerdetails",
		      query: {
		        id: e
		      }
		    });
		  },
	  }
	};
</script>

<style scoped>
	body{
		background: #ffffff;
	}
	.weus_type{
		width: calc(170px - 40px) ;
		padding: 30px 20px;
		text-align: center;
		background-color: #f9f9f9;
		border-radius: 8px;
		font-size: 16px;
		min-height: 800px;
		line-height: 50px;
	}
	.weustype_item{
		padding: 0 20px;
		
	}
	.type_on{
		background-color: #1b9d57;
		color: #fff;
		border-radius: 6px;
	}
	.weus_main{
		width: 1200px;
		
	}
	.weus_topimg{
		padding-bottom: 30px;
		
	}
	.weus_topimg img{
		width: 100%;
		border-radius: 10px;
		height: 248.75px;	
	}
	.weus_titles{
		line-height: 45px;
		    padding: 10px 0 15px 32px;
		    color:#909399;
	}
	.upfrom{
		padding: 10px 0 15px 32px;
	}
	.weus_title{
		    font-size: 31px;
		    color: #303133;
			text-align: left;
	}
	.weus_tips{
			font-size: 14px;
			text-align: left;
	}
	.weus_html{
		text-align: left;
	}
	
	#appbox{
		background: #ffffff;
	}
	.Home_column2{
		width: 1200px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		margin: 0 auto;
		margin-top: 20px;
	}
	.expert_box{
		width:calc(100% - 40px);
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 20px;
		
	}
	.expert_img{
		width: 300px;
	
	}
	.expert_img img{
		width: 100%;
		object-fit: contain;
	}
	.expert_msgbox{
		flex: 1;
		margin-left: 20px;
		
	}
	.expert_title{
		padding: 20px;
		font-size: 20px;
		color:#1b9d57 !important;
		    font-weight: 600;
		    text-align: center;
	}
	.expert_msg{
		text-indent:4rem;
		font-size: 16px;
		color: #606266;
		    text-align: left;
	}
	.guidebox{
		padding: 30px 0px;
		border-top: 1px solid #EBEEF5;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items:center;
	}
	.guide_img{
		width: 480px;
		
	}
	.guide_img img{
		display: block;
		width: 100%;
		border-radius: 8px;
		object-fit: contain;
	}
	
	.guide_msgbox{
		width: calc(100% - 500px);
		
	}
	.guide_title{
		font-size: 28px;
		    color: #333;
		    line-height: 40px;
			    text-align: left;
	}
	.guide_subtitle{
		font-size: 18px;
		    color: #666;
		    line-height: 28px;
		    margin-top: 5px;
			    text-align: left;
	}
	.guide_msg{
		    margin: 30px 0px 50px;
		width: 490px;
		    font-size: 14px;
		    color: #666;
		    line-height: 30px;
			    text-align: left;
	}
	.guide_buttons{
		display: flex;
		justify-content: flex-start;
		
	}
	.column2_box{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: flex-end;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
		margin-bottom: 30px;
	}
	.expert_subtitle{
		text-indent:2rem;
		font-size: 14px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		    /* min-height: 48px; */
		
	}
	.mentor_imgs{
		width:100px !important;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		max-width: 210px;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
	  .intro_box{
		display: flex;
		justify-content: space-between;
		/* font-family: "楷体", "KaiTi", "SimKai", serif; */
		/* align-items: center; */
		
	  }
	  .intro_img{
		width: 280px;
		height: 280px;
		
	   }
	   .intro_title{
		font-size: 28px;
		color: rgb(32, 150, 150);
		margin-bottom: 15px;
	
	   }
	   .intro_subtitle{
		text-align: start;
		font-size: 20px;
		color: rgb(32, 150, 150);
		font-weight: bold;
		margin: 10px 0px;
	   }
	   
	  
	    .intro_paragraph{
		padding-left: 35px;
		text-align: start;
		font-size: 18px;
		letter-spacing: 1px;
		padding-top: 4px;
		padding-bottom: 4px;
		line-height: 25px;
		color: #333;
	   }
	   .intro_content{
		
		text-indent: 2em;
		text-align: start;
		font-size: 18px;
		letter-spacing: 1px;
		line-height: 25px;
		color: #333;
	   }
	   .intro_phonebox{
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	   }
	   .intro_phone{
		width: 33%;
		text-align: start;
		margin-top: 10px;
		font-size: 18px;
		letter-spacing: 1px;
	   }
       .intro_paragraph2{
        text-indent: 2rem;
       }
</style>